// actions.js
import { FETCH_EMPLOYEES_FAILURE, FETCH_EMPLOYEES_REQUEST, FETCH_EMPLOYEES_SUCCESS } from "./actionType"


export const fetchEmployeesRequest = () => ({
    type: FETCH_EMPLOYEES_REQUEST
})

export const fetchEmployeesSuccess = (employees) => ({
    type: FETCH_EMPLOYEES_SUCCESS,
    payload: employees
})

export const fetchEmployeesFailure = (error) => ({
    type: FETCH_EMPLOYEES_FAILURE,
    payload: error
})
